export default [
  { id: 1, 작업내용: '방수공사',
    유해위험요인: '방수자재를 트럭으로 반입 중 주변 근로자와 트럭 충돌',
    개선대책: '1. 자재 반입 시 신호수를 배치하여 트럭과 근로자의 \n    충돌 방지',
  },
  { id: 2, 작업내용: '방수공사',
    유해위험요인: '방수자재를 지게차로 하역 중 방수자재가 균형을 \n잃고 낙하',
    개선대책: '1. 방수자재 하역 시 작업지휘자를 배치하여 작업절차를 \n    준수하도록 철저히 관리',
  },
  { id: 3, 작업내용: '방수공사',
    유해위험요인: '방수자재 적재장소에서 화기 사용 중 인화성 \n방수자재에 착화 및 화재 발생',
    개선대책: '1. 인화성 방수자재 적재장소에 화기사용 금지 조치 실시',
  },
  { id: 4, 작업내용: '방수공사',
    유해위험요인: '보안경을 미착용한 채 망치를 사용하는 바탕물 \n처리작업 시 비산물에 의한 안구 손상 위험',
    개선대책: '1. 망치, 정 등을 사용하여 바탕면처리 작업 시 보안경 착용',
  },
  { id: 5, 작업내용: '방수공사',
    유해위험요인: '핸드그라인더를 사용하여 콘크리트 면처리 작업 중 감전',
    개선대책: '1. 핸드그라인더 사용 전 피복손상 여부 등을 점검하고 \n    접지상태를 확인, 누전차단기 사용',
  },
  { id: 6, 작업내용: '방수공사',
    유해위험요인: '방수면 처리작업 중 안전난간이 미설치로 인해 \n슬라브 단부로 추락',
    개선대책: '1. 방수면 처리작업 전 작업장소\n' +
      '2. 주변의 추락 위험장소에 안전난간 등의 추락 방지조치 실시',
  },
  { id: 7, 작업내용: '방수공사',
    유해위험요인: '사다리를 이용하여 방수면 처리장소로 이동 중 \n사다리가 쓰러져 근로자 추락',
    개선대책: '1. 사다리를 이용하여 작업장소 이동 시 사다리가 \n    쓰러지지 않도록 상·하부 고정 등의 사전조치 이행',
  },
  { id: 8, 작업내용: '방수공사',
    유해위험요인: '고소 작업 시 이동식 비계 작업발판 및 난간의 설치 불량으로 인해 추락',
    개선대책: '1. 이동식비계 작업발판과 안전난간을 설치하고 무너짐 \n    방지조치 실시',
  },
  { id: 9, 작업내용: '방수공사',
    유해위험요인: '토치 등 화기 사용 시 화상위험',
    개선대책: '1. 토치 등 화기 사용 시 화상방지용 안전장갑 착용',
  },
  { id: 10, 작업내용: '방수공사',
    유해위험요인: '개구부 주위 방수작업 중 개구부에서 추락',
    개선대책: '1. 개구부가 있는 장소는 작업 전 개구부 덮개 등 \n    방호조치 실시',
  },
  { id: 11, 작업내용: '방수공사',
    유해위험요인: '작업장 주변부 안전난간대 등의 방호 조치 미실시로 인해 작업 중 추락',
    개선대책: '1. 작업장 주변 개구부에 덮개, 슬라브 단부에 안전난간을 설치',
  },
  { id: 12, 작업내용: '방수공사',
    유해위험요인: '지하 밀폐공간에서 방수작업 중 유독가스 또는 \n산소 부족으로 의한 질식',
    개선대책: '1. 밀폐공간에서 방수작업시 환기시설 설치, 산소농도, \n    가스농도 등을 측정하여 안전성 확인',
  },
]
